"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEARCH_STATUS = void 0;
const SEARCH_STATUS = exports.SEARCH_STATUS = {
  Auction: 'auction',
  Available: 'available',
  Error: 'error',
  None: 'none',
  PreReg: 'prereg',
  Restricted: 'restricted',
  SearchInProgress: 'searching',
  Taken: 'taken',
  Unavailable: 'unavailable'
};